import { ArticleCard } from '@components/common/Card/ArticleCard';
import { ThumbnailPosition } from '@components/common/Card/shared/Thumbnail/Thumbnail.types';
import { Variant } from '@components/common/Card/shared/Variant.types';
import { MEDIA_QUERIES, useMediaQuery } from '@student-coin/coinpaper-components';
import { Fragment, ReactElement, useEffect, useMemo, useState } from 'react';
import { Articles, Container, Divider, Header } from './RelatedArticles.styles';
import { ArticleCardsProps } from './RelatedArticles.types';

export const RelatedArticles = ({
  items,
  header,
  desktopCardView,
  mobileCardView,
  border,
  grid,
  oneLineAuthor,
  noFooter = false,
}: ArticleCardsProps): ReactElement => {
  const [options, setOptions] = useState<{
    thumbnail: ThumbnailPosition;
    variant: Variant;
    withDescription?: boolean;
    sponsored?: boolean;
    isCollection?: boolean;
    collectionCount?: number;
    oneLineAuthor: boolean;
  }>({
    thumbnail: 'left',
    variant: 'small',
    withDescription: false,
    oneLineAuthor,
  });
  const isTabletWide = useMediaQuery(MEDIA_QUERIES.tablet);
  const hasHeader = Boolean(header?.text);

  useEffect(() => {
    const optionsObject = isTabletWide ? desktopCardView : mobileCardView;

    const newOptions = { ...options, ...optionsObject };

    if (JSON.stringify(options) !== JSON.stringify(newOptions)) {
      setOptions(newOptions);
    }
  }, [isTabletWide, desktopCardView, mobileCardView, options]);

  const size = useMemo(() => {
    return isTabletWide ? 'mediumXs' : 'roundish';
  }, [isTabletWide]);

  const headingSize = useMemo(() => {
    return isTabletWide ? '1.6875rem' : '1.125rem';
  }, [isTabletWide]);

  const breadcrumbSize = useMemo(() => {
    return isTabletWide ? '0.875rem' : '0.75rem';
  }, [isTabletWide]);

  return (
    <Container border={border}>
      {hasHeader && <Header variant={header.variant}>{header.text}</Header>}
      <Articles border={border} grid={grid}>
        {items.map((article, index) => {
          return (
            article && (
              <Fragment key={article.href}>
                <ArticleCard
                  href={article.href}
                  article={article.article}
                  {...options}
                  size={size}
                  noFooter={!isTabletWide || noFooter}
                  headingSize={headingSize}
                  breadcrumbSize={breadcrumbSize}
                />
                {index < items.length - 1 ? <Divider /> : null}
              </Fragment>
            )
          );
        })}
      </Articles>
    </Container>
  );
};
